var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavIconBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3571 13C14.4014 13 12 15.43 12 18.3571C12 19.3797 12.4628 20.2634 12.8913 20.9033C13.3217 21.5431 13.7616 21.9526 13.7616 21.9526L21.4877 29.6997L22 30.2139L22.5142 29.6997L30.2403 21.9526C30.2403 21.9526 32 20.3986 32 18.3571C32 15.43 29.6005 13 26.6448 13C24.192 13 22.6113 14.4759 22 15.0986C21.3887 14.4759 19.8099 13 17.3571 13Z",
    stroke: "#75593A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconBrown);
export default __webpack_public_path__ + "static/media/favIconBrown.a19ff5eef729e051a00cdd091117c3a0.svg";
export { ForwardRef as ReactComponent };